/**
 * Replaces diagram-js SelectionVisuals with a no-op.
 * Prevents the blue selection outline/frame from appearing on selected BPMN elements.
 * Selection behavior (click to select, properties panel) still works via the Selection service.
 */
const noSelectionVisualsModule = {
  selectionVisuals: ['type', NoSelectionVisuals]
};
export default noSelectionVisualsModule;

function NoSelectionVisuals() {
  // No-op: do not add 'selected' or 'hover' markers to elements.
  // The Selection service still handles selection state; we just skip the visual feedback.
}

(NoSelectionVisuals as any).$inject = ['canvas', 'eventBus'];
